import React, { useEffect, useState, useRef } from "react";
import LabsButton from "./LabsButton.jsx";
import PrivacyPolicyLink from "./PrivacyPolicyLink.jsx";
import styled from "styled-components";
import Logo from "./Logo.jsx";
import no_profile from "../img/profile.png";
import inquiry from "../img/inquiry.png";
import plus from "../img/plus.png";
import close_button from "../img/close_button.png";
import inquiryLogBar from "../img/inquiry.png";
import terms from "../img/terms.png";
import invite from "../img/invite_gift.png";
import lawGranted from "../img/5_law_granted.png";
import ModalMyPage from "../Components/Modal/ModalMyPage.jsx";
import ModalFriendInvite from "./Modal/ModalFriendInvite.jsx";
import LogList from "../Components/LogList.jsx";
import ModalInquiry from "./Modal/ModalInquiry.jsx";
import ModalTermsOfService from "../Components/Modal/ModalTermsOfService.jsx";
import { gradientBorder } from "../styles/mixin.js";
import useStore from "../store.js";
import { useChatNavigation } from "./ChatNavigationProvider.jsx";

const BannerMobile = ({ isChatHeader = false }) => {
  // 전역 상태로 사이드바 관리
  const isMobileSidebarOpen = useStore((state) => state.isMobileSidebarOpen);
  const setMobileSidebarOpen = useStore((state) => state.setMobileSidebarOpen);

  // 질문 내역은 이 헤더에 속한다. PC 레이아웃 전환 등으로 헤더가 사라지면 열림 상태도 닫는다.
  useEffect(() => () => setMobileSidebarOpen(false), [setMobileSidebarOpen]);

  /* 이용약관 모달창 */
  const [isTermsModalOpen, setTermsModalIsOpen] = useState(false);
  const handleOpenTermsModal = () => {
    setTermsModalIsOpen(true);
  };
  const handleCloseTermsModal = () => {
    setTermsModalIsOpen(false);
  };

  /* 문의하기 모달창 */
  const [isInquiryModalOpen, setInquiryModalIsOpen] = useState(false);
  const handleOpenInquiryModal = () => {
    setInquiryModalIsOpen(true);
  };
  const handleCloseInquiryModal = () => {
    setInquiryModalIsOpen(false);
  };

  /* 친구초대 모달창 */
  const [isFriendInviteModalOpen, setFriendInviteModalIsOpen] = useState(false);
  const handleOpenFriendInviteModal = () => {
    setFriendInviteModalIsOpen(true);
  };
  const handleCloseFriendInviteModal = () => {
    setFriendInviteModalIsOpen(false);
  };

  /* 마이페이지 모달창 */
  const [isMyPageModalOpen, setMyPageModalIsOpen] = useState(false);
  const imgRef = useRef(null);

  const handleOpenMyPageModal = () => {
    setMyPageModalIsOpen(true);
  };
  const handleCloseMyPageModal = () => {
    setMyPageModalIsOpen(false);
  };

  // 로그바를 여는 함수
  const toggleLogbar = () => {
    setMobileSidebarOpen(true);
  };

  // 회색 배경을 클릭하여 로그바를 닫는 함수
  const closeLogbar = () => {
    setMobileSidebarOpen(false);
  };

  const { requestNewSituation } = useChatNavigation();

  return (
    <Wrapper
      as={isChatHeader ? "header" : "div"}
      $isChatHeader={isChatHeader}
      data-testid={isChatHeader ? "mobile-chat-header" : undefined}
    >
      <HeaderIconButton
        type="button"
        onClick={toggleLogbar}
        aria-label="질문 내역 열기"
        title="질문 내역 열기"
        $isChatHeader={isChatHeader}
      >
        <StyledLogButtonImage
          src={inquiryLogBar}
          alt=""
        />
      </HeaderIconButton>

      {/* 왼쪽 로그바 */}
      <LogbarMobile $isOpen={isMobileSidebarOpen}>
        {/* 로그바 내용 */}
        <LogbarTitle>
          <CustomButton
            $width="70%"
            $height="50px"
            $gap={10}
            onClick={requestNewSituation}>
            <ButtonImg
              src={plus}
              alt="새로운 상황"
              $imgWidth={36}
              $imgHeight={36}
            />
            <ButtonText>새로운 상황</ButtonText>
          </CustomButton>
          <ButtonStyles onClick={closeLogbar}>
            <img
              src={close_button}
              alt="close-button"
              width="24px"
              height="24px"
            />
          </ButtonStyles>
        </LogbarTitle>
        <LogList  onLogClick={closeLogbar} />
        <InquiryTermsBox>
          {/* 친구초대 메뉴 */}
          <ModalFriendInvite
            isOpen={isFriendInviteModalOpen}
            onClose={handleCloseFriendInviteModal}
          />
          <FriendInviteContainer>
            <CustomButton
              $width="100%"
              $height="44px"
              onClick={() => handleOpenFriendInviteModal(true)}
              $gap={8}>
              <ButtonImg
                src={invite}
                alt="친구초대"
                $imgWidth={32}
                $imgHeight={32}
              />
              <ButtonText>친구초대</ButtonText>
            </CustomButton>
            <BadgeOverlay>
              <BadgeImage src={lawGranted} alt="5로우 즉시 지급" />
            </BadgeOverlay>
          </FriendInviteContainer>
          <LabsButton sidebar inset={10} onClick={closeLogbar} />
          <ModalInquiry
            isOpen={isInquiryModalOpen}
            onCloseInquiry={handleCloseInquiryModal}
          />
          <CustomButton
            $width="100%"
            $height="44px"
            onClick={() => handleOpenInquiryModal(true)}
            $gap={8}>
            <ButtonImg
              src={inquiry}
              alt="문의하기"
              $imgWidth={32}
              $imgHeight={32}
            />
            <ButtonText>문의하기</ButtonText>
          </CustomButton>
          <ModalTermsOfService
            isOpen={isTermsModalOpen}
            onClose={handleCloseTermsModal}
          />
          <CustomButton
            $width="100%"
            $height="44px"
            onClick={() => handleOpenTermsModal(true)}
            $gap={8}>
            <ButtonImg
              src={terms}
              alt="이용약관"
              $imgWidth={32}
              $imgHeight={32}
            />
            <ButtonText>이용약관</ButtonText>
          </CustomButton>
          <PrivacyPolicyLink inset={10} />
        </InquiryTermsBox>
      </LogbarMobile>
      {/* 사이드바가 열렸을 때, 회색 배경 */}
      {isMobileSidebarOpen && <LogbarOverlay onClick={closeLogbar} />}

      <Logo />

      <ModalMyPage
        isOpen={isMyPageModalOpen}
        onClose={handleCloseMyPageModal}
        width="275px"
        height="auto"
        title="마이페이지"
        triggerRef={imgRef}
      />
      <StyledImageWrapper
        ref={imgRef}
        type="button"
        aria-label="내 계정 열기"
        title="내 계정 열기"
        $isChatHeader={isChatHeader}
        onClick={() => imgRef.current && handleOpenMyPageModal()} // 이미지 ref가 유효한 경우에만 모달 열기
      >
        <StyledImage src={no_profile} alt="" />
      </StyledImageWrapper>
    </Wrapper>
  );
};

const CustomButton = styled.button`
  padding-top: 8px;
  padding-left: 10px;
  padding-bottom: 10px;
  background-color: transparent;
  width: ${(props) => (props.$width === "auto" ? "auto" : `${props.$width}`)};
  height: ${(props) => (props.$height === "auto" ? "auto" : `${props.$height}`)};
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  gap: ${(props) => (props.$gap !== undefined ? `${props.$gap}px` : "0px")};
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const ButtonImg = styled.img`
  width: ${(props) =>
    props.$imgWidth === "auto" ? "auto" : `${props.$imgWidth}px`};
  height: ${(props) =>
    props.$imgHeight === "auto" ? "auto" : `${props.$imgHeight}px`};
  flex-shrink: 0;
`;

const ButtonText = styled.span`
  font-family: Pretendard;
  font-style: normal;
  color: ${(props) => props.fontColor || "rgba(0, 0, 0, 0.6)"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "600"};
  line-height: ${(props) => props.lineHeight || "26px"};
  padding-right: ${(props) => props.paddingRight || "0px"};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: ${({ $isChatHeader }) => ($isChatHeader ? "0" : "initial")};
  width: ${({ $isChatHeader }) => ($isChatHeader ? "100%" : "auto")};
  min-height: ${({ $isChatHeader }) =>
    $isChatHeader
      ? "calc(56px + env(safe-area-inset-top, 0px))"
      : "initial"};
  padding: ${({ $isChatHeader }) =>
    $isChatHeader
      ? "env(safe-area-inset-top, 0px) 24px 0"
      : "0"};
  box-sizing: border-box;
  background: ${({ $isChatHeader }) => ($isChatHeader ? "#fff" : "transparent")};

  @media (min-width: 600px) {
    min-height: ${({ $isChatHeader }) =>
      $isChatHeader
        ? "calc(64px + env(safe-area-inset-top, 0px))"
        : "initial"};
    padding-right: ${({ $isChatHeader }) => ($isChatHeader ? "36px" : "0")};
    padding-left: ${({ $isChatHeader }) => ($isChatHeader ? "36px" : "0")};
  }
`;

const HeaderIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $isChatHeader }) => ($isChatHeader ? "36px" : "40px")};
  height: ${({ $isChatHeader }) => ($isChatHeader ? "36px" : "40px")};
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #00e879;
    outline-offset: 2px;
  }
`;

const StyledLogButtonImage = styled.img`
  width: 100%;
  height: 100%;
`;

// Mobile, 왼쪽 로그바 컴포넌트
const LogbarMobile = styled.div`
  position: fixed;
  top: 0;
  left: ${(props) =>
    props.$isOpen ? "0" : "-320px"}; /* isOpen 상태에 따라 왼쪽으로 이동 */
  width: 312px;
  height: 100%;
  background-color: #fff;
  transition: left 0.3s ease; /* 왼쪽 이동 효과 추가 */
  z-index: 101; /* 회색 배경 위에 표시 */
  display: flex;
  flex-direction: column;
`;

const LogbarTitle = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  height: 96px; /* 기종에 따라 height가 늘어나거나 줄어드는 경우가 있어 35%(약 307px)으로 맞춤 */
  margin-left: 10px;
`;

const ButtonStyles = styled.div`
  border: none;
  background: transparent;
  display: inline;
  position: absolute;
  right: 24px;
`;

// 사이드바가 열렸을 때, 회색 배경 컴포넌트
const LogbarOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 투명도를 조절하여 회색 배경을 생성 */
  z-index: 100; /* 다른 요소 위에 표시 */
`;

const StyledImageWrapper = styled.button`
  ${gradientBorder}

  position: relative;
  width: ${({ $isChatHeader }) => ($isChatHeader ? "36px" : "40px")};
  height: ${({ $isChatHeader }) => ($isChatHeader ? "36px" : "40px")};
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 50%; // 원형 테두리를 유지하기 위해 50%로 설정
  overflow: hidden;
  display: inline-flex;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #00e879;
    outline-offset: 2px;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: relative;
  z-index: 1;
  box-sizing: border-box; // 테두리를 포함한 크기 계산
`;

const InquiryTermsBox = styled.div`
  flex-shrink: 0;
  margin-top: auto; /* 바닥에 붙게 하기 */
  padding: 0 10px; 
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 84px;
  display: flex;
  flex-direction: column;
  gap: 2px; /* 위아래 2px 간격 */
  
  @media (max-width: 1439px) and (min-width: 600px){
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 24px;
  }

  @media (max-width: 599px) {
    // display: none; // 모바일 사이드바에도 문의하기/이용약관 버튼 추가
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 24px;
    margin-top: 10px; /* 임시 적용 */
  }
`;

const FriendInviteContainer = styled.div`
  position: relative;
  margin-bottom: 2px;
`;

const BadgeOverlay = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-46%);
  pointer-events: none; /* 클릭 이벤트가 버튼으로 전달되도록 */
`;

const BadgeImage = styled.img`
  width: 132px;
  height: 36px;
  object-fit: contain;
`;

export default BannerMobile;
